module.exports = __webpack_public_path__ + "static/media/pricing-3.04bb76df.png";